import React from 'react'
import { useTranslation } from 'react-i18next'

import { ACTION } from '../../fields'

import Field from '../../../../../../components/Form/Field'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function ActionsOrCommentsSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Actions or comments')}</h3>
      <p>{t('Details of any outstanding actions or comments for the partner (if any)')}</p>
      <Field placeholder="Action for the partner" formik={formik} name={ACTION} enableReinitialize />
    </section>
  )
}

export default ActionsOrCommentsSection
